define(
({
  "alert": "警報",
  "okay": "OK"
})
);
